import { LabelAssignment } from '@provision/entity-types';
import { Address } from 'src/graphql/entities/address/address';
import { EntityNames } from 'src/graphql/types';

export enum AppEvents {
  ClientsToAddressAssociation = 'clientsToAddressAssociation',
  SearchRecordsInvalidated = 'searchRecordsInvalidated',
  LabelAssignmentChanged = 'labelAssignmentChanged',
  ConversationAttachmentsChanged = 'conversationAttachmentsChanged',
}

type AppEventsPayload = {
  [AppEvents.ClientsToAddressAssociation]: { clientIds: string[]; address: Address };
  [AppEvents.SearchRecordsInvalidated]: { entityName: EntityNames; viewId: string };
  [AppEvents.LabelAssignmentChanged]: {
    entity: string;
    entityId: string;
    labelId: string;
    operation: 'create' | 'delete';
    assignment?: Partial<LabelAssignment>;
  };
  [AppEvents.ConversationAttachmentsChanged]: {
    conversationId: string;
    attachments: {
      __typename: 'ConversationAttachment';
      id: string;
      conversationAttachmentId: string;
      conversationId: string;
      partnerId: number;
      fileKey: string;
      fileName: string;
      contentType: string;
      size: number;
      createdAt: string;
    }[];
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const pubsub = new Map<string | number, Set<(...args: any[]) => any>>();

export function emitAppEvent<T extends AppEvents>(eventType: T, payload: AppEventsPayload[T]) {
  const set = pubsub.get(eventType);
  if (!set || set.size === 0) return;

  const callbacks = Array.from(set);
  for (const cb of callbacks) {
    cb(payload);
  }
}

export function subscribeToAppEvent<T extends AppEvents>(
  eventType: T,
  eventCallback: (payload: AppEventsPayload[T]) => void,
) {
  if (!pubsub.has(eventType)) {
    pubsub.set(eventType, new Set());
  }
  const set = pubsub.get(eventType)!;
  set.add(eventCallback);

  return function unsubscribe() {
    const current = pubsub.get(eventType);
    if (!current) return;
    current.delete(eventCallback);
    if (current.size === 0) {
      pubsub.delete(eventType);
    }
  };
}
